// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.provisioning.openid4vci

import org.multipaz.cbor.DataItem
import org.multipaz.provisioning.openid4vci.OpenID4VCIAuthorizationData
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr

internal fun OpenID4VCIAuthorizationData.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "tSadM4JcWvdA3nqneHBRndJAVEbWdmRFofbJYGqORLA")
internal val OpenID4VCIAuthorizationData_cborSchemaId = ByteString(-75, 38, -99, 51, -126, 92, 90, -9, 64, -34, 122, -89, 120, 112, 81, -99, -46, 64, 84, 70, -42, 118, 100, 69, -95, -10, -55, 96, 106, -114, 68, -80)

internal fun OpenID4VCIAuthorizationData.Companion.fromCbor(data: ByteArray): OpenID4VCIAuthorizationData {
    return OpenID4VCIAuthorizationData.fromDataItem(Cbor.decode(data))
}

internal val OpenID4VCIAuthorizationData.Companion.cborSchemaId: ByteString
    get() = OpenID4VCIAuthorizationData_cborSchemaId

internal fun OpenID4VCIAuthorizationData.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("issuerUri", Tstr(this.issuerUri))
    builder.put("configurationId", Tstr(this.configurationId))
    builder.put("secureAreaId", Tstr(this.secureAreaId))
    val authorizationServer = this.authorizationServer
    if (authorizationServer != null) {
        builder.put("authorizationServer", Tstr(authorizationServer))
    }
    val refreshToken = this.refreshToken
    if (refreshToken != null) {
        builder.put("refreshToken", Tstr(refreshToken))
    }
    val dpopKeyAlias = this.dpopKeyAlias
    if (dpopKeyAlias != null) {
        builder.put("dpopKeyAlias", Tstr(dpopKeyAlias))
    }
    val walletAttestationKeyAlias = this.walletAttestationKeyAlias
    if (walletAttestationKeyAlias != null) {
        builder.put("walletAttestationKeyAlias", Tstr(walletAttestationKeyAlias))
    }
    val walletAttestation = this.walletAttestation
    if (walletAttestation != null) {
        builder.put("walletAttestation", Tstr(walletAttestation))
    }
    builder.put("type", Tstr(this.type))
    return builder.end().build()
}

internal fun OpenID4VCIAuthorizationData.Companion.fromDataItem(dataItem: DataItem): OpenID4VCIAuthorizationData {
    val issuerUri = dataItem["issuerUri"].asTstr
    val configurationId = dataItem["configurationId"].asTstr
    val secureAreaId = dataItem["secureAreaId"].asTstr
    val authorizationServer0 = if (dataItem.hasKey("authorizationServer")) {
        dataItem["authorizationServer"].asTstr
    } else {
        null
    }
    val refreshToken0 = if (dataItem.hasKey("refreshToken")) {
        dataItem["refreshToken"].asTstr
    } else {
        null
    }
    val dpopKeyAlias0 = if (dataItem.hasKey("dpopKeyAlias")) {
        dataItem["dpopKeyAlias"].asTstr
    } else {
        null
    }
    val walletAttestationKeyAlias0 = if (dataItem.hasKey("walletAttestationKeyAlias")) {
        dataItem["walletAttestationKeyAlias"].asTstr
    } else {
        null
    }
    val walletAttestation0 = if (dataItem.hasKey("walletAttestation")) {
        dataItem["walletAttestation"].asTstr
    } else {
        null
    }
    val type = dataItem["type"].asTstr
    return OpenID4VCIAuthorizationData(
        issuerUri = issuerUri,
        configurationId = configurationId,
        secureAreaId = secureAreaId,
        authorizationServer = authorizationServer0,
        refreshToken = refreshToken0,
        dpopKeyAlias = dpopKeyAlias0,
        walletAttestationKeyAlias = walletAttestationKeyAlias0,
        walletAttestation = walletAttestation0,
        type = type,
    )
}
